<ion-app [class.menu-open]="isMenuOpen()">
  <div class="splash-overlay" *ngIf="showSplash">
    <div class="splash-content">
      <app-orb class="splash-orb" state="listening" [size]="64" [px]="230" label="Cargando SmartBreak"></app-orb>
      <img
        class="splash-logo"
        src="assets/images/isotipo_smartbreak.png"
        alt="Logotipo SmartBreak"
        loading="eager"
      />
    </div>
  </div>
  <ion-split-pane when="(min-width: 992px)" contentId="main-content">
    <!-- Menu lateral -->
    <ion-menu
      side="start"
      menuId="main-menu"
      type="overlay"
      contentId="main-content"
      class="ion-menu glass-menu"
      [disabled]="!showGlobalChrome"
      [hidden]="!showGlobalChrome"
      (ionWillOpen)="onMenuWillOpen()"
      (ionDidOpen)="onMenuDidOpen()"
      (ionWillClose)="onMenuWillClose()"
      (ionDidClose)="onMenuDidClose()"
    >
      <ng-container *ngIf="showGlobalChrome">
        <app-navigation
          [username]="username"
          [workType]="userWorkTypeLabel"
          [avatarKey]="userAvatarKey"
          [customAvatar]="userAvatarPhoto"
          [userPoints]="userPoints"
          (logout)="logout()"
        ></app-navigation>
      </ng-container>
    </ion-menu>

    <!-- Contenido principal -->
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <!-- Barra de puntaje fija (arriba a la derecha; se oculta cuando el menú lateral está abierto) -->
  <div class="global-score-bar" *ngIf="showGlobalChrome" [class.global-score-bar--hidden]="isMenuOpen() || (overlayLock.open$ | async)">
    <app-online-users></app-online-users>
    <app-notifications-bell></app-notifications-bell>
    <app-smart-score-widget></app-smart-score-widget>
  </div>

  <app-push-prompt-modal
    *ngIf="showPushPromptModal && currentUserIdForPrompt"
    [userId]="currentUserIdForPrompt"
    (closeModal)="onPushPromptClosed($event)"
  ></app-push-prompt-modal>

  <app-install-app-banner *ngIf="isLoggedIn && !isFullScreenRoute && !showIosInstallHint"></app-install-app-banner>

  <app-ios-install-banner
    *ngIf="showIosInstallHint && isLoggedIn && !isFullScreenRoute"
    (dismissed)="showIosInstallHint = false"
  ></app-ios-install-banner>

  <app-password-prompt-modal *ngIf="showPasswordPromptModal" (closeModal)="closePasswordPrompt()"></app-password-prompt-modal>

  <app-dates-prompt-modal
    *ngIf="showDatesPromptModal && currentUserIdForPrompt"
    [needed]="datesNeeded"
    [userId]="currentUserIdForPrompt"
    (closeModal)="closeDatesPrompt()"
  ></app-dates-prompt-modal>

  <app-daily-checkin-modal *ngIf="showDailyCheckinModal" (closeModal)="closeDailyCheckinModal()"></app-daily-checkin-modal>

  <app-climate-pulse-modal *ngIf="climatePulse.question$ | async"></app-climate-pulse-modal>

  <app-smart-score-modal
    *ngIf="gamificationService.showBreakdown$ | async"
    [summary]="gamificationService.summary$ | async"
    (close)="closeSmartScoreModal()"
  ></app-smart-score-modal>

  <app-game-invite-banner *ngIf="isLoggedIn"></app-game-invite-banner>

  <app-update-banner></app-update-banner>
  <app-medal-celebration></app-medal-celebration>
  <app-celebration-host></app-celebration-host>
  <app-breaky-companion *ngIf="isLoggedIn && !isFullScreenRoute" [class.overlay-hidden]="overlayLock.open$ | async"></app-breaky-companion>
</ion-app>
